import { Instagram, PawPrint } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useI18n } from '../lib/i18n';

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="site-footer">
      <div className="footer-brand"><PawPrint size={20} /><div><strong>Pawtrait Studio</strong><span>Dog Photography</span></div></div>
      <div className="footer-links">
        <Link to="/book">{t('book')}</Link><a href="/#pricing">{t('pricing')}</a><a href="/#contact">{t('contact')}</a><Link to="/privacy">{t('privacy')}</Link><Link to="/terms">{t('terms')}</Link><a href="#" aria-label="Instagram"><Instagram size={18} /></a><Link className="footer-admin" to="/admin">Admin</Link>
      </div>
      <div className="footer-copy">© {new Date().getFullYear()} Pawtrait Studio</div>
    </footer>
  );
}
